import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Svg from '@bibliocommons/svg';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';
import { bibShape, shelfItemShape, userIdentityShape, ugcIOwnThisShape } from '@bibliocommons/bc-prop-types';
import AddToShelfButton from './AddToShelfButton';
import OnShelfDropdown from './OnShelfDropdown';

import './ShelfActionsButton.scss';

function renderPlaceholder() {
  return (
    <Svg className="button-placeholder" width="170" height="40" viewBox="0 0 170 40" preserveAspectRatio="none">
      <path d="M165.526316,0 L4.47368421,0 C2.00293665,0 0,1.91877964 0,4.28571429 L0,35.7142857 C0,38.0812204 2.00293665,40 4.47368421,40 L165.526316,40 C167.997063,40 170,38.0812204 170,35.7142857 L170,4.28571429 C170,1.91877964 167.997063,0 165.526316,0 Z M4.47368421,0.952380952 L165.526316,0.952380952 C167.448008,0.952380952 169.005848,2.44476512 169.005848,4.28571429 L169.005848,35.7142857 C169.005848,37.5552349 167.448008,39.047619 165.526316,39.047619 L4.47368421,39.047619 C2.55199166,39.047619 0.994152047,37.5552349 0.994152047,35.7142857 L0.994152047,4.28571429 C0.994152047,2.44476512 2.55199166,0.952380952 4.47368421,0.952380952 Z" />
    </Svg>
  );
}

export default class ShelfActionsButton extends React.PureComponent {
  dropdownRef = React.createRef();

  addButtonRef = React.createRef();

  componentDidUpdate(prevProps) {
    const { bib, shelfItem, shelfTransactions } = this.props;
    const currentTransaction = shelfTransactions.get(bib.get('id'));
    const prevTransaction = prevProps.shelfTransactions.get(bib.get('id'));
    const transactionCompleted = prevTransaction && !currentTransaction;

    if (transactionCompleted) {
      const shelfItemAdded = !prevProps.shelfItem && shelfItem;
      const shelfItemRemoved = prevProps.shelfItem && !shelfItem;

      if (shelfItemAdded && this.dropdownRef.current) {
        setFocusWithinElement(this.dropdownRef.current);
      }

      if (shelfItemRemoved && this.addButtonRef.current) {
        setFocusWithinElement(this.addButtonRef.current);
      }
    }
  }

  renderContent() {
    if (this.props.shelfItem && this.props.user) {
      return <OnShelfDropdown {...this.props} ref={this.dropdownRef} />;
    }

    return (
      <AddToShelfButton
        {...this.props}
        ref={this.addButtonRef}
        screenReaderMessage={this.props.screenReaderMessageAddToShelf}
      />
    );
  }

  render() {
    const { block, isLoading } = this.props;

    const classNames = cn('cp-shelf-actions-button', {
      'shelf-actions-button--block': block
    });

    return <div className={classNames}>{isLoading ? renderPlaceholder() : this.renderContent()}</div>;
  }
}

ShelfActionsButton.propTypes = {
  bib: bibShape.isRequired,
  primaryShelfName: PropTypes.string,
  shelfItem: shelfItemShape,
  iOwnThis: ugcIOwnThisShape,
  user: userIdentityShape,
  shelfTransactions: ImmutablePropTypes.map,
  block: PropTypes.bool,
  rounded: PropTypes.bool,
  disabled: PropTypes.bool,
  right: PropTypes.bool,
  isLoading: PropTypes.bool,
  reciprocalRank: PropTypes.number,
  handleDeleteSuccess: PropTypes.func,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iOwnThisActions: PropTypes.objectOf(PropTypes.func).isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iconOnly: PropTypes.bool,
  screenReaderMessageAddToShelf: PropTypes.string,
  trackContentCollectionMove: PropTypes.func
};
